
export default {
  name: 'DaisoStaticImage',
  inheritAttrs: false,
  props: {
    src: {
      type: [String, null],
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    priority: {
      type: Boolean,
      default: false
    },
    loading: {
      type: String,
      default: null
    },
    fetchpriority: {
      type: String,
      default: null
    },
    decoding: {
      type: String,
      default: 'async'
    },
    fallbackEnabled: {
      type: Boolean,
      default: true
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isErrorHandled: false,
      noImagePath: '/images/tempLy/noimage.png',
      currentSrc: null
    }
  },
  computed: {
    nativeListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.load
      delete listeners.error
      return listeners
    },
    effectiveLoading () {
      return this.loading || (this.priority ? 'eager' : 'lazy')
    },
    effectiveFetchpriority () {
      return this.fetchpriority || (this.priority ? 'high' : 'auto')
    },
    processedSrc () {
      if (!this.src) {
        return this.fallbackEnabled ? this.fallbackSrc : this.src
      }
      if (this.isErrorHandled) {
        return this.fallbackEnabled ? this.fallbackSrc : this.src
      }
      return this.src
    },
    fallbackSrc () {
      return this.error || this.noImagePath
    }
  },
  watch: {
    src: {
      immediate: true,
      handler () {
        this.isErrorHandled = false
        this.currentSrc = this.processedSrc
      }
    }
  },
  beforeDestroy () {
    // 로딩 중인(미완료) 이미지만 src를 비워 네트워크 요청을 취소한다.
    // 이미 로드 완료된 이미지는 그대로 둔다 - 떠나는 페이지는 어차피 곧 통째로 제거되므로
    // 여기서 지우면 그 순간 화면에 깨진 이미지 아이콘이 잠깐 노출된다(DEV-11335).
    const el = this.$el
    if (el && el.tagName === 'IMG' && !el.complete) {
      el.removeAttribute('src')
      el.removeAttribute('srcset')
    }
  },
  methods: {
    load (event) {
      this.$emit('load', event)
    },
    errorImage (event) {
      if (!this.isErrorHandled) {
        this.isErrorHandled = true
        if (this.fallbackEnabled) {
          this.currentSrc = this.fallbackSrc
        }
        this.$emit('error', event)
      }
    }
  }
}
